export default __webpack_public_path__ + "static/media/antek.2435c5b3.svg";